export const CONTENT_LABELS: Record<string, string> = {
  podcast: "Listen",
  video: "Watch",
  article: "Read more",
};
